(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-slider-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initializeImageSliders() {
      var sliders = document.querySelectorAll('.js-image-slider');
      
      if (!sliders.length) return;
      
      sliders.forEach(function (slider, index) {
        // Get settings from data attributes
        var enableSwiperDesktop = slider.getAttribute('data-enable-swiper-desktop') === 'true';
        var enableSwiperMobile = slider.getAttribute('data-enable-swiper-mobile') === 'true';
        var desktopColumns = parseInt(slider.getAttribute('data-desktop-columns') || '4');
        var mobileColumns = parseInt(slider.getAttribute('data-mobile-columns') || '2');
        var isDesktop = window.innerWidth >= 750;
        var autoplay = slider.getAttribute('data-autoplay') === 'true';
        var autoplayDelay = parseInt(slider.getAttribute('data-autoplay-delay') || '5') * 1000;
        
        // Determine if we should initialize swiper
        var shouldInitSwiper = (isDesktop && enableSwiperDesktop) || (!isDesktop && enableSwiperMobile);
        
        // Clean up existing swiper if needed
        if (slider.swiper && !shouldInitSwiper) {
          slider.swiper.destroy(true, true);
          slider.swiper = null;
        }
        
        if (!shouldInitSwiper) return;
        
        // Only initialize if we don't already have a swiper instance
        if (!slider.swiper) {
          var slideCount = slider.querySelectorAll('.swiper-slide').length;
          slider.classList.add('is' + index);
          
          var container = slider.parentElement;
          var nextEl = container ? container.querySelector('.js-image-slider-btn.swiper-button-next') : null;
          var prevEl = container ? container.querySelector('.js-image-slider-btn.swiper-button-prev') : null;
          var paginationEl = container ? container.querySelector('.js-image-slider-pagination.swiper-pagination') : null;
          var shouldLoop = slider.getAttribute('data-loop') === 'true';
          
          // Adjust slidesPerView for mobile when set to 1 column
          var mobileSlidesPerView = mobileColumns === 1 ? 1.25 : mobileColumns;
          
          var swiperConfig = {
            slidesPerView: isDesktop ? desktopColumns : mobileSlidesPerView,
            spaceBetween: isDesktop ? 30 : 16,
            speed: 300,
            breakpointsBase: 'container',
            cssMode: false,
            loop: shouldLoop,
            centeredSlides: !isDesktop && mobileColumns === 1,
            watchOverflow: false,
            passiveListeners: true,
            shortSwipes: true,
            touchAngle: 45,
            mousewheel: {
              releaseOnEdges: false,
              forceToAxis: true,
              sensitivity: 0.25,
            },
            breakpoints: {
              750: {
                slidesPerView: desktopColumns,
                spaceBetween: 30,
                centeredSlides: false,
              },
              480: {
                slidesPerView: mobileColumns === 1 ? 1.25 : mobileColumns,
                spaceBetween: 16,
                centeredSlides: mobileColumns === 1,
              },
              0: {
                slidesPerView: mobileColumns === 1 ? 1.25 : mobileColumns,
                spaceBetween: 16,
                centeredSlides: mobileColumns === 1,
              }
            },
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            pagination: {
              el: paginationEl,
              clickable: true,
            },
            on: {
              init: function (sw) {
                if (sw.params.loop) {
                  if (prevEl) prevEl.classList.remove('swiper-button-disabled');
                  if (nextEl) nextEl.classList.remove('swiper-button-disabled');
                  if (sw.navigation && sw.navigation.update) sw.navigation.update();
                }
              },
            },
          };
          
          // Add autoplay if enabled
          if (autoplay) {
            swiperConfig.autoplay = {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            };
          }
          
          var swiper = new Swiper(slider, swiperConfig);
        }
      });
    }
    
    // Initialize on load
    initializeImageSliders();
    
    // Re-initialize on resize to handle desktop/mobile switching
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initializeImageSliders();
      }, 250);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initializeCarousels() {
      var carousels = document.querySelectorAll('.js-products-carousel');
      
      if (!carousels.length) return;
      
      carousels.forEach(function (carousel, index) {
        // Get settings from data attributes
        var enableSwiperDesktop = carousel.getAttribute('data-enable-swiper-desktop') === 'true';
        var enableSwiperMobile = carousel.getAttribute('data-enable-swiper-mobile') === 'true';
        var isDesktop = window.innerWidth >= 750;
        
        // Determine if we should initialize swiper
        var shouldInitSwiper = (isDesktop && enableSwiperDesktop) || (!isDesktop && enableSwiperMobile);
        
        // Clean up existing swiper if needed
        if (carousel.swiper && !shouldInitSwiper) {
          carousel.swiper.destroy(true, true);
          carousel.swiper = null;
        }
        
        if (!shouldInitSwiper) return;
        
        // Only initialize if we don't already have a swiper instance
        if (!carousel.swiper) {
          var slideCount = carousel.querySelectorAll('.swiper-slide').length;
          carousel.classList.add('s' + index);
          
          var container = carousel.parentElement;
          var nextEl = container ? container.querySelector('.js-products-carousel-btn.swiper-button-next') : null;
          var prevEl = container ? container.querySelector('.js-products-carousel-btn.swiper-button-prev') : null;
          var paginationEl = container ? container.querySelector('.js-products-carousel-pagination.swiper-pagination') : null;
          var shouldLoop = carousel.getAttribute('data-loop') === 'true' && slideCount >= 6;
          
          var swiper = new Swiper(carousel, {
            slidesPerView: 'auto',
            centeredSlides: true,
            speed: 300,
            breakpointsBase: 'container',
            cssMode: false,
            loop: shouldLoop,
            watchOverflow: false,
            passiveListeners: true,
            shortSwipes: true,
            touchAngle: 45,
            mousewheel: {
              releaseOnEdges: false,
              forceToAxis: true,
              sensitivity: 0.25,
            },
            breakpoints: {
              480: {
                centeredSlides: false,
              },
            },
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            pagination: {
              el: paginationEl,
              clickable: true,
            },
            on: {
              init: function (sw) {
                if (sw.params.loop) {
                  if (prevEl) prevEl.classList.remove('swiper-button-disabled');
                  if (nextEl) nextEl.classList.remove('swiper-button-disabled');
                  if (sw.navigation && sw.navigation.update) sw.navigation.update();
                }
              },
            },
          });
        }
      });
    }
    
    // Initialize on load
    initializeCarousels();
    
    // Re-initialize on resize to handle desktop/mobile switching
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initializeCarousels();
      }, 250);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
